// FIXME: Fix this the next time the file is edited.
// @ts-expect-error TS(6133): 'channel' is declared but its value is never read.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { channel } from "redux-saga";
// FIXME: Fix this the next time the file is edited.
// @ts-expect-error TS(6192): All imports in import declaration are unused.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { delay, fork, put, race, take, takeEvery } from "redux-saga/effects";

// FIXME: Fix this the next time the file is edited.
// @ts-expect-error TS(6133): 'IActionWithPayload' is declared but its value is ... Remove this comment to see the full error message
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { IActionWithPayload } from "store/helper";

// FIXME: Fix this the next time the file is edited.
// @ts-expect-error TS(6192): All imports in import declaration are unused.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { TicketActivityActions, TicketActivityActionsNames } from "./actions";

// FIXME: Fix this the next time the file is edited.
// @ts-expect-error TS(6196): 'IActivityActionPayload' is declared but never use... Remove this comment to see the full error message
// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface IActivityActionPayload {
  agentID: string;
  ticketID: string;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* ticketActivitySagas() {}
